export type FixedDate = {
  date: string;
  duration?: number;
};
